import { createContext } from "react";

const ShortFormContext = createContext(null as any);

export default ShortFormContext;
